<div class="promote-setting-modal">
  <div class="modal-header">
    <h2>{{ title }}</h2>
    <button aria-label="Close" class="close-button" type="button" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="promotion-info">
      <p class="info-text">
        <strong>Please verify the following setting details before {{ isReview ? 'approving promotion to' : 'promoting to' }} {{ targetEnvironment }}:</strong>
      </p>
      <p class="warning-text">
        <i class="lx-icon lx-alert"></i>
        Check each field to confirm the values are correct. This action will apply the setting in {{ targetEnvironment }}.
      </p>
      <p *ngIf="showDiff" class="diff-summary">
        <ng-container *ngIf="changedFieldCount > 0">
          Approving will change {{ changedFieldCount }} field{{ changedFieldCount === 1 ? '' : 's' }} in {{ targetEnvironment }} (highlighted below).
        </ng-container>
        <ng-container *ngIf="changedFieldCount === 0">
          These values already match what is in {{ targetEnvironment }}.
        </ng-container>
      </p>
      <p *ngIf="isReview && !showDiff" class="diff-summary">
        This setting does not yet exist in {{ targetEnvironment }} — approving will create it.
      </p>
    </div>

    <form [formGroup]="verificationForm">
      <div class="verification-list" formArrayName="verifications">
        <div *ngFor="let field of fields; let i = index" class="verification-item" [class.changed]="field.changed">
          <div class="field-info">
            <label class="field-label">{{ field.label }}:</label>
            <!-- Review-mode update: show a before -> after diff, highlighting changed fields. -->
            <span *ngIf="field.changed" class="field-diff">
              <span class="field-value old-value">{{ field.previousValue || '(empty)' }}</span>
              <i class="lx-icon lx-arrow-right diff-arrow"></i>
              <span class="field-value new-value" [class.long-value]="field.value?.length > 50">{{ field.value || '(empty)' }}</span>
            </span>
            <span *ngIf="!field.changed" class="field-value" [class.long-value]="field.value?.length > 50">{{ field.value }}</span>
          </div>
          <div class="checkbox-wrapper">
            <input
              type="checkbox"
              [id]="'verify-' + i"
              [formControlName]="i"
              class="verification-checkbox">
            <label [for]="'verify-' + i" class="checkbox-label">Verified</label>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="button-group">
      <button class="btn-cancel" type="button" [disabled]="isPromoting" (click)="onCancel()">
        Cancel
      </button>
      <button
        class="btn-promote"
        type="button"
        [disabled]="!allFieldsVerified || isPromoting"
        (click)="onPromote()">
        <span *ngIf="!isPromoting">{{ confirmLabel }}</span>
        <span *ngIf="isPromoting" class="spinner-container">
          <span class="spinner"></span>
          {{ inProgressLabel }}
        </span>
      </button>
    </div>
  </div>
</div>
